<script setup lang="ts">
import type { ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'

import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'SlotsHeaderTab',
})

const props = withDefaults(defineProps<SlotsHeaderTabProps>(), {
  selected: false,
  disabled: false,
  point: false,
})

const emit = defineEmits<{
  click: [ShortDaysOfWeek]
}>()

interface SlotsHeaderTabProps {
  id: ShortDaysOfWeek
  text: string
  selected?: boolean
  disabled?: boolean
  point?: boolean
}

const handleClick = (): void => {
  emit('click', props.id)
}
</script>

<template>
  <button
    :class="['slots-tab', { selected, disabled, point }]"
    @click="handleClick"
  >
    <AppText name="body1-medium">
      {{ text }}
    </AppText>
    <span
      v-if="point"
      class="slots-tab__point"
    />
  </button>
</template>

<style scoped lang="scss" src="./SlotsHeaderTab.scss" />
